import React from 'react';
import './footer.css';

const Footer = () => {
	return (
        <div className="footer-container" id="footer">
            <div className="footer m-auto">
                <div className="child links">
                    <p>Let's chat!</p>
                    <a href="https://www.instagram.com/mauriciofcost/" target="_blank"> Instagram</a>
                    <a href="https://www.linkedin.com/in/maufcost/" target="_blank"> LinkedIn</a>
                    <a href="mailto:mauricio.fmc.gt@gmail.com" target="_blank">Email</a>
                    <a href="https://open.spotify.com/artist/5LlHzdScgU69K05pBln5ca?si=RgrV7aJ0S-mXGJNxFk7mVA" target="_blank">Spotify</a>
                    <a href="https://bmc.link/mauriciocosta" target="_blank">Buy Me a Coffee</a>
                    <a href="https://youtube.com/@mauriciocosta1761" target="_blank">Youtube</a>
                </div>
                <div className="child form">
                    <p style={{ fontWeight: 500 }}>Would you like to take part in the <i>The Valley Musical</i> or any future musicals? Drop us a message on the socials.</p>
                    {/* <input type="text" /> */}
                    {/* <button>Send</button> */}
                </div>
            </div>
        </div>
    )
}

export default Footer;
